@mixin background {
  border-radius: 10px;
}

.key-board-row {
  .key-board-row-block {
    padding-left: 0;
    padding-right: 0;
    @include background;
    .label {
      white-space: nowrap;
      padding-bottom: 5px;
      font-size: 20px;
      font-weight: 100;
      width: 50%;
    }

    .remove-padding {
      padding-left: 0;
      padding-right: 0;
    }

    .boolean-component {
      float: none !important;
    }

    @media (min-width: 501px) and(max-width: 1000px){
      .boolean-component {
       // float: right !important;
      }
    }

    @media (min-width: 768px) and (max-width: 850px) {
      .tab-view {
        width: 50% !important;
      }
      .tab-view-none{
        display: none;
      }

    }
  }

  @media (max-width: 767px) {
    .key-board-row-block {
      .mobile-view {
        padding-right: 0 !important;
        padding-left: 0 !important;
      }
    }
  }
}




// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/settings/display-and-keyboard/key-board/key-board.scss